import React from 'react';
import { string } from 'prop-types';
import styled from 'styled-components';
//import { animateScroll as scroll } from 'react-scroll';
import { ArrowLeftCircle } from 'react-feather';
import { useHistory } from 'react-router-dom';

const Button = styled.button`
  background: ${({ theme }) => theme.buttonBackground};
  border: 2px solid ${({ theme }) => theme.buttonBorder};
  color: ${({ theme }) => theme.text};
  border-radius: 30px;
  cursor: pointer;
  font-size:0.8rem;
  padding: 0.6rem;
  }`;

const BackButton = ({ theme }) => {
  const history = useHistory();

  return (
    <div>
      <Button
        id='back-button'
        onClick={() => {
          history.push('/');
        }}
      >
        <ArrowLeftCircle className='social-icons' /> Back
      </Button>
    </div>
  );
};
BackButton.propTypes = {
  theme: string.isRequired,
};

export default BackButton;
